/**
 * DIVYAM MURTI - SHOPIFY OS 2.0 THEME JAVASCRIPT
 * Real-time AJAX Cart API, Drawer Controls, Modal Search, and Variant Selection
 */

window.DivyamTheme = window.DivyamTheme || {};
if (!window.DivyamTheme.moneyFormat) {
  window.DivyamTheme.moneyFormat = '${{amount}}';
}
if (typeof window.DivyamTheme.freeShippingThreshold === 'undefined') {
  window.DivyamTheme.freeShippingThreshold = 200;
}

// --- Toast Notification ---
function showToast(message) {
  let toast = document.getElementById('dmToast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'dmToast';
    toast.style.cssText = `
      position: fixed;
      bottom: 24px;
      left: 50%;
      transform: translateX(-50%) translateY(100px);
      background: #141312;
      color: #ede8e3;
      padding: 12px 24px;
      font-size: 0.75rem;
      letter-spacing: 0.08em;
      border-radius: 4px;
      z-index: 9999;
      box-shadow: 0 10px 30px rgba(0,0,0,0.25);
      border-left: 3px solid #c5a059;
      transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
      pointer-events: none;
    `;
    document.body.appendChild(toast);
  }
  toast.textContent = message;
  toast.style.transform = 'translateX(-50%) translateY(0)';
  setTimeout(() => {
    toast.style.transform = 'translateX(-50%) translateY(100px)';
  }, 3500);
}

// --- Format Money Helper (Fully Shopify Currency Aware) ---
function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  cents = parseInt(cents, 10);
  if (isNaN(cents)) cents = 0;

  let formatString = format || (window.DivyamTheme && window.DivyamTheme.moneyFormat) || '${{amount}}';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = typeof precision === 'undefined' ? 2 : precision;
    thousands = typeof thousands === 'undefined' ? ',' : thousands;
    decimal = typeof decimal === 'undefined' ? '.' : decimal;

    if (isNaN(number) || number == null) return '0';

    const numFixed = (number / 100.0).toFixed(precision);
    const parts = numFixed.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const centsStr = parts[1] && precision > 0 ? decimal + parts[1] : '';

    return dollars + centsStr;
  }

  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const match = formatString.match(placeholderRegex);

  if (!match) {
    const symbol = (window.DivyamTheme && window.DivyamTheme.currencySymbol) || '';
    return symbol + (cents / 100.0).toFixed(2);
  }

  let value = '';
  switch (match[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2, ',', '.');
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0, ',', '.');
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ', '.');
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', ',');
      break;
    default:
      value = formatWithDelimiters(cents, 2, ',', '.');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}
window.formatMoney = formatMoney;

// --- Shopify AJAX Cart API Engine ---
const CartAPI = {
  getCart: async function() {
    try {
      const res = await fetch('/cart.js');
      return await res.json();
    } catch (e) {
      console.error('Failed to fetch Shopify cart:', e);
      return null;
    }
  },

  addItem: async function(variantId, quantity = 1, properties = {}) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: parseInt(quantity, 10),
            properties: properties
          }]
        })
      });

      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.description || 'Could not add item to cart');
      }

      const cart = await CartAPI.getCart();
      if (cart) {
        renderCartUI(cart);
        openCartDrawer();
        showToast('Added sacred sculpture to your Sanctum Cart');
      }
      return cart;
    } catch (err) {
      console.error(err);
      showToast(err.message || 'Unable to add sculpture');
    }
  },

  changeItem: async function(lineIndex, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          line: lineIndex,
          quantity: parseInt(quantity, 10)
        })
      });

      const cart = await res.json();
      renderCartUI(cart);
      return cart;
    } catch (err) {
      console.error('Failed to change cart item:', err);
      showToast('Error updating cart');
    }
  },

  updateNote: async function(note) {
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note })
      });
      showToast('Sanctum consecration notes saved');
    } catch (err) {
      console.error('Failed to save cart note:', err);
    }
  }
};

// --- Render Cart Across All Components ---
function renderCartUI(cart) {
  if (!cart) return;

  // 1. Update header and drawer count badges
  const countBadges = document.querySelectorAll('.cart-count');
  countBadges.forEach(el => el.textContent = cart.item_count);

  // 2. Render Slide-out Drawer
  renderSideCartDrawer(cart);

  // 3. Render Full Cart Page Table (if present)
  renderFullCartPage(cart);
}

function renderSideCartDrawer(cart) {
  const container = document.getElementById('cartDrawerItems');
  const subtotalEl = document.getElementById('cartDrawerSubtotal');
  const footerEl = document.getElementById('cartDrawerFooter');
  const shippingMeter = document.getElementById('cartShippingMeter');
  const shippingText = document.getElementById('cartShippingText');
  const shippingFill = document.getElementById('cartShippingFill');

  if (!container) return;

  if (cart.item_count === 0) {
    container.innerHTML = `
      <div class="cart-empty-state">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <h4>Your Cart is Empty</h4>
        <p>Explore our curated collection of handcrafted sculptures and art pieces.</p>
        <a href="/collections/all" class="btn-explore" onclick="closeCartDrawer()">Explore Collection</a>
      </div>
    `;
    if (footerEl) footerEl.style.display = 'none';
    if (shippingMeter) shippingMeter.style.display = 'none';
    return;
  }

  if (footerEl) footerEl.style.display = 'block';
  if (shippingMeter) shippingMeter.style.display = 'block';

  // Free shipping threshold calculations
  const thresholdCents = (window.DivyamTheme.freeShippingThreshold || 200) * 100;
  const currentTotal = cart.total_price;
  const pct = Math.min(100, Math.round((currentTotal / thresholdCents) * 100));

  if (shippingFill) shippingFill.style.width = `${pct}%`;
  if (shippingText) {
    if (currentTotal >= thresholdCents) {
      shippingText.innerHTML = `<strong>Complimentary Museum-Grade Insured Shipping Unlocked!</strong>`;
    } else {
      const remaining = formatMoney(thresholdCents - currentTotal);
      shippingText.innerHTML = `Add <strong>${remaining}</strong> for Complimentary Insured Shipping`;
    }
  }

  let html = '';
  cart.items.forEach((item, index) => {
    const lineIndex = index + 1; // Shopify lines are 1-based
    const itemImg = item.image ? item.image : '';
    const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? ` • ${item.variant_title}` : '';

    html += `
      <div class="cart-item-card" data-line="${lineIndex}">
        <div class="cart-item-image">
          <img src="${itemImg}" alt="${item.title}">
        </div>
        <div class="cart-item-details">
          <h5>${item.product_title}</h5>
          <div class="cart-item-meta">${variantTitle.replace(' • ', '')}</div>
          <div class="cart-qty-control">
            <button class="cart-qty-btn" onclick="CartAPI.changeItem(${lineIndex}, ${item.quantity - 1})" aria-label="Decrease quantity">−</button>
            <span class="cart-qty-val">${item.quantity}</span>
            <button class="cart-qty-btn" onclick="CartAPI.changeItem(${lineIndex}, ${item.quantity + 1})" aria-label="Increase quantity">+</button>
          </div>
        </div>
        <div class="cart-item-right">
          <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
          <button class="cart-item-remove" onclick="CartAPI.changeItem(${lineIndex}, 0)">Remove</button>
        </div>
      </div>
    `;
  });

  container.innerHTML = html;
  if (subtotalEl) {
    subtotalEl.textContent = formatMoney(cart.total_price);
  }
}

function renderFullCartPage(cart) {
  const container = document.getElementById('fullCartItemsContainer');
  const subtotalEl = document.getElementById('pageSubtotal');
  const totalEl = document.getElementById('pageFinalTotal');
  if (!container) return;

  if (cart.item_count === 0) {
    container.innerHTML = `
      <div style="text-align: center; padding: 60px 20px;">
        <p style="font-family: var(--font-serif); font-size: 1.4rem; margin-bottom: 12px;">Your cart is currently empty.</p>
        <p style="font-size: 0.78rem; color: var(--text-muted); margin-bottom: 24px;">Discover our collection of handcrafted sculptures and art pieces.</p>
        <a href="/collections/all" class="btn-primary">Explore Collection</a>
      </div>
    `;
    if (subtotalEl) subtotalEl.textContent = formatMoney(0);
    if (totalEl) totalEl.textContent = formatMoney(0);
    return;
  }

  let html = '';
  cart.items.forEach((item, index) => {
    const lineIndex = index + 1;
    const itemImg = item.image || '';
    const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? ` • ${item.variant_title}` : '';

    html += `
      <div class="cart-full-row">
        <div class="cart-prod-cell">
          <div class="cart-prod-thumb">
            <img src="${itemImg}" alt="${item.title}">
          </div>
          <div class="cart-prod-info">
            <h4>${item.product_title}</h4>
            <p>${variantTitle.replace(' • ', '')}</p>
            <button class="cart-row-remove" onclick="CartAPI.changeItem(${lineIndex}, 0)">Remove</button>
          </div>
        </div>
        <div>
          <div class="cart-qty-control">
            <button class="cart-qty-btn" onclick="CartAPI.changeItem(${lineIndex}, ${item.quantity - 1})">−</button>
            <span class="cart-qty-val">${item.quantity}</span>
            <button class="cart-qty-btn" onclick="CartAPI.changeItem(${lineIndex}, ${item.quantity + 1})">+</button>
          </div>
        </div>
        <div class="cart-price-cell">
          ${formatMoney(item.final_line_price)}
        </div>
      </div>
    `;
  });

  container.innerHTML = html;
  if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
}

// --- Side Drawer Controls ---
function openCartDrawer() {
  const drawer = document.getElementById('cartDrawer');
  const backdrop = document.getElementById('cartDrawerBackdrop');
  if (drawer && backdrop) {
    drawer.classList.add('active');
    backdrop.classList.add('active');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
  }
}

function closeCartDrawer() {
  const drawer = document.getElementById('cartDrawer');
  const backdrop = document.getElementById('cartDrawerBackdrop');
  if (drawer && backdrop) {
    drawer.classList.remove('active');
    backdrop.classList.remove('active');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  }
}

// --- Search Modal Controls ---
function openSearch() {
  const searchOverlay = document.getElementById('searchOverlay');
  const searchBackdrop = document.getElementById('searchBackdrop');
  const searchInput = document.getElementById('searchInput');
  if (searchOverlay && searchBackdrop) {
    searchOverlay.classList.add('active');
    searchBackdrop.classList.add('active');
    searchOverlay.setAttribute('aria-hidden', 'false');
    if (searchInput) setTimeout(() => searchInput.focus(), 150);
  }
}

function closeSearch() {
  const searchOverlay = document.getElementById('searchOverlay');
  const searchBackdrop = document.getElementById('searchBackdrop');
  if (searchOverlay && searchBackdrop) {
    searchOverlay.classList.remove('active');
    searchBackdrop.classList.remove('active');
    searchOverlay.setAttribute('aria-hidden', 'true');
  }
}

// --- Mobile Navigation Drawer Controls ---
function openMobileDrawer() {
  const mobileDrawer = document.getElementById('mobileDrawer');
  const drawerBackdrop = document.getElementById('drawerBackdrop');
  if (mobileDrawer && drawerBackdrop) {
    mobileDrawer.classList.add('active');
    drawerBackdrop.classList.add('active');
    mobileDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('menu-open');
  }
}

function closeMobileDrawer() {
  const mobileDrawer = document.getElementById('mobileDrawer');
  const drawerBackdrop = document.getElementById('drawerBackdrop');
  if (mobileDrawer && drawerBackdrop) {
    mobileDrawer.classList.remove('active');
    drawerBackdrop.classList.remove('active');
    mobileDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('menu-open');
  }
}

// --- Image Gallery Switcher (PDP) ---
function switchMainImage(src, btnEl) {
  if (typeof selectGallerySlide === 'function' && btnEl && btnEl.hasAttribute('data-index')) {
    selectGallerySlide(parseInt(btnEl.getAttribute('data-index'), 10));
    return;
  }
  const mainImg = document.getElementById('mainProductImage');
  if (mainImg) mainImg.src = src;
  document.querySelectorAll('.thumbnail-btn').forEach(b => b.classList.remove('active'));
  if (btnEl) btnEl.classList.add('active');
}

// --- Product Detail Accordions ---
function toggleAccordion(btnEl) {
  const item = btnEl.closest('.accordion-item');
  if (!item) return;
  const isAlreadyActive = item.classList.contains('active');
  if (isAlreadyActive) {
    item.classList.remove('active');
    btnEl.setAttribute('aria-expanded', 'false');
  } else {
    item.classList.add('active');
    btnEl.setAttribute('aria-expanded', 'true');
  }
}

// --- Global Initialization ---
document.addEventListener('DOMContentLoaded', async () => {
  // Initial cart load from Shopify
  const cart = await CartAPI.getCart();
  if (cart) renderCartUI(cart);

  // Search Open / Close Triggers
  const searchOpenBtn = document.getElementById('searchOpenBtn');
  const searchCloseBtn = document.getElementById('searchCloseBtn');
  const searchBackdrop = document.getElementById('searchBackdrop');
  if (searchOpenBtn) searchOpenBtn.addEventListener('click', openSearch);
  if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearch);
  if (searchBackdrop) searchBackdrop.addEventListener('click', closeSearch);

  // Mobile Menu Triggers
  const mobileMenuBtn = document.getElementById('mobileMenuBtn');
  const drawerCloseBtn = document.getElementById('drawerCloseBtn');
  const drawerBackdrop = document.getElementById('drawerBackdrop');
  if (mobileMenuBtn) mobileMenuBtn.addEventListener('click', openMobileDrawer);
  if (drawerCloseBtn) drawerCloseBtn.addEventListener('click', closeMobileDrawer);
  if (drawerBackdrop) drawerBackdrop.addEventListener('click', closeMobileDrawer);

  // Cart Drawer Triggers
  const cartOpenBtns = document.querySelectorAll('.cart-open-btn');
  const cartCloseBtn = document.getElementById('cartCloseBtn');
  const cartDrawerBackdrop = document.getElementById('cartDrawerBackdrop');
  cartOpenBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openCartDrawer();
    });
  });
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCartDrawer);
  if (cartDrawerBackdrop) cartDrawerBackdrop.addEventListener('click', closeCartDrawer);

  // Keyboard accessibility: Escape key closes active overlays
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeSearch();
      closeMobileDrawer();
      closeCartDrawer();
    }
  });

  // Intercept Quick Add buttons on product cards
  document.body.addEventListener('click', (e) => {
    const quickAddBtn = e.target.closest('.quick-add-btn');
    if (quickAddBtn) {
      e.preventDefault();
      const variantId = quickAddBtn.getAttribute('data-variant-id');
      if (variantId) {
        CartAPI.addItem(variantId, 1);
      }
    }
  });
});
